import ImageType from "components/Content/RelatedArticles/PropTypes/ImageType";
import PropTypes from "prop-types";

const ArticleType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  image: ImageType,
});

export default ArticleType;
